<template>
  <c-403-error />
  <div v-if="authenticated" id="nav">
    <nav v-if="!authUserIsAdmin()" class="nav-gradient">
      <div
        class="container nav-gradient-bar d-flex justify-content-between align-items-center"
      >
        <router-link to="/admin/marcos-legales-generales" class="nav-logo">
          <img src="/img/logo.png" alt="Logo" width="50" />
        </router-link>
        <div class="nav-actions d-flex align-items-center">
          <ul class="list-unstyled m-0 nav-gradient-menu">
            <li class="d-inline-block">
              <router-link
                to="/admin/marcos-legales-generales"
                class="text-decoration-none nav-gradient-link"
              >
                <i class="fa-solid fa-scale-balanced"></i>
                Marcos legales
              </router-link>
            </li>
            <li class="d-inline-block">
              <router-link
                to="/matriz-legal"
                class="text-decoration-none nav-gradient-link"
              >
                <i class="fa-solid fa-table-cells"></i>
                Mi Matriz
              </router-link>
            </li>
            <li class="nav-item dropdown d-inline-block">
              <a
                class="nav-link dropdown-toggle nav-gradient-link"
                href="#"
                id="navbarDropdownUser"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="fa-solid fa-gear"></i>
                Configuración
              </a>
              <ul
                class="dropdown-menu border-0"
                aria-labelledby="navbarDropdownUser"
              >
                <li>
                  <router-link
                    to="/admin/configuraciones/aspectos/"
                    class="text-decoration-none dropdown-item"
                    >Aspecto</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/admin/configuraciones/autoridades-regulatorias/"
                    class="text-decoration-none dropdown-item"
                    >Autoridad regulatoria</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/admin/configuraciones/frecuencias/"
                    class="text-decoration-none dropdown-item"
                    >Frecuencia</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/admin/configuraciones/ordenamientos"
                    class="text-decoration-none dropdown-item"
                    >Ordenamiento</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/admin/configuraciones/semaforos/"
                    class="text-decoration-none dropdown-item"
                    >Semáforo</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/admin/configuraciones/tipos-de-verificacion/"
                    class="text-decoration-none dropdown-item"
                    >Tipo de verificación</router-link
                  >
                </li>
              </ul>
            </li>
          </ul>
          <div class="dropdown">
            <button
              class="nav-menu nav-profile-btn small"
              data-bs-toggle="dropdown"
            >
              <i class="fa-solid fa-user"></i>
            </button>
            <ul class="dropdown-menu border-0 shadow-sm dropdown-menu-end">
              <li>
                <router-link class="dropdown-item small" to="/perfil"
                  >Perfil</router-link
                >
              </li>
              <li>
                <a
                  @click="logOut"
                  href="javascript:void(0)"
                  class="dropdown-item small"
                >
                  Cerrar sesión
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>

    <div v-else class="nav-top">
      <div class="container d-flex justify-content-between align-items-center">
        <router-link to="/admin/usuarios">
          <img src="/img/logo.png" alt="Logo" width="50" />
        </router-link>
        <div class="d-flex align-items-center">
          <nav class="admin-nav">
            <ul class="list-unstyled m-0">
              <li class="d-inline-block">
                <router-link to="/admin/usuarios" class="text-decoration-none"
                  >Usuarios</router-link
                >
              </li>
            </ul>
          </nav>
          <div class="dropdown">
            <button
              class="nav-menu c-bg-primary small"
              data-bs-toggle="dropdown"
            >
              EP
            </button>
            <ul class="dropdown-menu border-0 shadow-sm dropdown-menu-end">
              <li>
                <a
                  @click="logOut"
                  href="javascript:void(0)"
                  class="dropdown-item small"
                >
                  Cerrar sesión
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="!authUserIsAdmin() && authUser.name"
      class="container user-name-container"
    >
      <p class="user-name">{{ authUser.name }}</p>
    </div>
  </div>
  <router-view />
</template>
<script>
import { logOut, authUser, authUserIsAdmin } from "@/services/auth";
import C403Error from "@/components/C403Error";

export default {
  components: {
    C403Error,
  },
  data() {
    return {
      authUser: {},
      authenticated: localStorage.getItem("logged"),
    };
  },
  mounted() {
    this.refreshAuthUser();
  },
  watch: {
    $route() {
      this.refreshAuthUser();
    },
  },
  methods: {
    refreshAuthUser() {
      this.authUser = authUser() || {};
    },
    async logOut() {
      this.loading = true;
      try {
        await logOut();
        localStorage.removeItem("logged");
        localStorage.removeItem("user");
        localStorage.removeItem("hasPlan");
        window.location.href = "/auth/login";
      } catch (error) {
        alert("No pudimos cerrar tu sesión, inténtalo nuevamente.");
        this.loading = false;
      }
    },
    authUserIsAdmin() {
      return authUserIsAdmin();
    },
  },
};
</script>
<style lang="sass" scoped>
#nav
  .nav-top
    padding: 0.4rem 0
    background-color: #fff

  .nav-menu
    border-radius: 50%
    width: 35px
    height: 35px
    border: 0
    color: white

  .admin-nav a
    color: #333333
    display: inline-block
    padding: 0 10px

.nav-gradient
  background: linear-gradient(90deg, #00A3FF 0%, #0080FF 45%, #00BFFF 100%)
  padding: 0.5rem 0
  box-shadow: 0 2px 8px rgba(0, 128, 255, 0.25)

.nav-gradient-bar
  gap: 1rem

.nav-logo
  flex-shrink: 0
  line-height: 0

.nav-profile-btn
  background-color: #fff !important
  color: #0080FF !important
  font-weight: 600
  display: inline-flex
  align-items: center
  justify-content: center

.nav-actions
  gap: 0.75rem
  margin-left: auto

.nav-gradient-menu
  display: flex
  align-items: center
  justify-content: flex-end
  gap: 0.25rem

.nav-gradient-link
  color: #fff !important
  display: inline-flex
  align-items: center
  gap: 0.4rem
  padding: 0.35rem 1rem
  font-weight: 500
  transition: opacity 0.2s ease

  i
    font-size: 0.95rem

  &:hover,
  &:focus
    color: #fff !important
    opacity: 0.85

  &.router-link-active
    font-weight: 700
    border-bottom: 2px solid #fff

.user-name-container
  padding-top: 0.75rem
  padding-bottom: 0.25rem

.user-name
  font-size: 1rem
  font-weight: 700
  margin: 0
  color: #04071d
</style>
